import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';

import {
  Avatar,
  Grid,
  Tooltip
} from '@mui/material';

import { loginAtom } from '../../lib/auth';

import {
  Typography
} from '../../components/interface';

import SunEditor from 'suneditor-react';
import SunEditorCore from "suneditor/src/lib/core";
import 'suneditor/dist/css/suneditor.min.css'

type AvailableLang = 'nl' | 'fr' | 'en';
type StyledEditorProps = {
  label: string;
  value: {[z:string]: string};
  activeLocale: AvailableLang;
  onChange: (z:{[y:string]: string}) => void;
};

export const StyledEditor: FunctionComponent<StyledEditorProps> = ({label, onChange, value, activeLocale}) => {
  const theme = useTheme();

  const [login, setLogin] = useAtom(loginAtom);
  const editor = useRef<SunEditorCore>();
  // const editorNl = useRef<SunEditorCore>();
  // const editorFr = useRef<SunEditorCore>();

  const [editorContent, setEditorContent] = useState<string>(value[activeLocale] || value.en || '');
  // const [editorContentAll, setEditorContentAll] = useState<{[z:string]: string}>(value);
  // const [editorContentFr, setEditorContentFr] = useState<string>(value.fr);
  const [inited, setInited] = useState<boolean>(false);
  const [usedActiveLocale, setUsedActiveLocale] = useState<AvailableLang>(activeLocale);

  useEffect(() => {
    setUsedActiveLocale(activeLocale);
  }, [activeLocale]);

  const getSunEditorInstance = (sunEditor: SunEditorCore) => {
    editor.current = sunEditor;
  };

  // const getSunEditorNlInstance = (sunEditor: SunEditorCore) => {
  //   editorNl.current = sunEditor;
  // };

  // const getSunEditorFrInstance = (sunEditor: SunEditorCore) => {
  //   editorFr.current = sunEditor;
  // };

  let setting_editor_height = '300px';
  // if (!!login && !!login.extra_data?.settings?.editor_height) setting_editor_height = login.extra_data.settings.editor_height;
  let setting_languages_split_raw = '0';
  // if (!!login && !!login.extra_data?.settings?.languages_split) setting_languages_split_raw = login.extra_data.settings.languages_split;
  let setting_languages_split = (setting_languages_split_raw === "1");

  useEffect(() => {
    if (!inited && !setting_languages_split && value[usedActiveLocale] !== editorContent) {
      // setEditorContent(value[usedActiveLocale]);
      editor.current?.setContents(value[usedActiveLocale]);
      setInited(true);
    }
    if (!inited && !!setting_languages_split) {
      // editorNl.current?.setContents(value.nl);
      // editorFr.current?.setContents(value.fr);
      // setEditorContentNl(value.nl);
      // setEditorContentFr(value.fr);
      setInited(true);
    }
  }, [value]);

  useEffect(() => {
    // console.log(usedActiveLocale, setting_languages_split, value, (!!value && !!value[usedActiveLocale] ? value[usedActiveLocale] : '<p><br/></p>'));
    if (!setting_languages_split) {
      editor.current?.setContents((!!value && !!value[usedActiveLocale] ? value[usedActiveLocale] : '<p><br/></p>'));
      // setEditorContent((!!value && !!value[usedActiveLocale] ? value[usedActiveLocale] : '<p><br/></p>'));
    }
  }, [usedActiveLocale]);

  useEffect(() => {
    // console.log('editorcontent changed', value);
    if (!!setting_languages_split) {
      // if (!!onChange) onChange({
      //   nl: editorContentNl || '',
      //   fr: editorContentFr || ''
      // });
    } else {
      if (!!onChange) onChange({
        ...value, 
        [usedActiveLocale]: editorContent || ''
      });
    }
  }, [editorContent]);

  return (<>
    {!!setting_languages_split && <>
      {/* <Grid item xs={12}>
        <Typography sx={{fontSize: '0.75rem'}}>{label} (NL)</Typography>
        <SunEditor
          height={setting_editor_height}
          getSunEditorInstance={getSunEditorNlInstance}
          setOptions={{
            defaultStyle: "font-size: 16px; font-family: 'Golos Text', sans-serif",
            buttonList: [
              ['undo', 'redo'],
              ['font', 'fontSize', 'formatBlock'],
              ['paragraphStyle', 'blockquote'],
              ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
              ['fontColor', 'hiliteColor', 'textStyle'],
              ['removeFormat'],
              '/',
              ['outdent', 'indent'],
              ['align', 'horizontalRule', 'list', 'lineHeight'],
              ['table', 'link', 'image', 'video'],
              // ['table', 'link', 'image', 'video', 'math'], // You must add the 'katex' library at options to use the 'math' plugin.
              // ['imageGallery'], // You must add the "imageGalleryUrl".
              ['fullScreen', 'showBlocks', 'codeView'],
              ['preview', 'print'],
              // ['save', 'template'],
              // ['dir', 'dir_ltr', 'dir_rtl'],
              // '/', Line break
            ]
          }}
          setContents={editorContentNl}
          onChange={(v) => {setEditorContentNl(v);}}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{fontSize: '0.75rem'}}>{label} (FR)</Typography>
        <SunEditor
          height={setting_editor_height}
          getSunEditorInstance={getSunEditorFrInstance}
          setOptions={{
            defaultStyle: "font-size: 16px; font-family: 'Golos Text', sans-serif",
            buttonList: [
              ['undo', 'redo'],
              ['font', 'fontSize', 'formatBlock'],
              ['paragraphStyle', 'blockquote'],
              ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
              ['fontColor', 'hiliteColor', 'textStyle'],
              ['removeFormat'],
              '/',
              ['outdent', 'indent'],
              ['align', 'horizontalRule', 'list', 'lineHeight'],
              ['table', 'link', 'image', 'video'],
              // ['table', 'link', 'image', 'video', 'math'], // You must add the 'katex' library at options to use the 'math' plugin.
              // ['imageGallery'], // You must add the "imageGalleryUrl".
              ['fullScreen', 'showBlocks', 'codeView'],
              ['preview', 'print'],
              // ['save', 'template'],
              // ['dir', 'dir_ltr', 'dir_rtl'],
              // '/', Line break
            ]
          }}
          setContents={editorContentFr}
          onChange={(v) => {setEditorContentFr(v);}}
        />
      </Grid> */}
    </>}
    
    {!setting_languages_split && <Grid item xs={12} sx={{position: 'relative'}}>
      <Tooltip title={(value['en'] || '').replace(/<\/?[^>]+(>|$)/g, "")}><Avatar
        sx={{position: 'absolute', cursor: 'pointer', opacity: (usedActiveLocale === 'en' ? 1 : 0.6), top: 12, right: 60, zIndex: 999, width: 24, height: 24, fontSize: '0.8rem', backgroundColor: ((value['en'] || '').replace(/<\/?[^>]+(>|$)/g, "") === '' ? 'red' : theme.palette.tertiary?.main)}}
        onClick={() => {setUsedActiveLocale('en');}}
      >EN</Avatar></Tooltip>
      <Tooltip title={(value['nl'] || '').replace(/<\/?[^>]+(>|$)/g, "")}><Avatar
        sx={{position: 'absolute', cursor: 'pointer', opacity: (usedActiveLocale === 'nl' ? 1 : 0.6), top: 12, right: 32, zIndex: 999, width: 24, height: 24, fontSize: '0.8rem', backgroundColor: ((value['nl'] || '').replace(/<\/?[^>]+(>|$)/g, "") === '' ? 'red' : theme.palette.tertiary?.main)}}
        onClick={() => {setUsedActiveLocale('nl');}}
      >NL</Avatar></Tooltip>
      <Tooltip title={(value['fr'] || '').replace(/<\/?[^>]+(>|$)/g, "")}><Avatar
        sx={{position: 'absolute', cursor: 'pointer', opacity: (usedActiveLocale === 'fr' ? 1 : 0.6), top: 12, right: 4, zIndex: 999, width: 24, height: 24, fontSize: '0.8rem', backgroundColor: ((value['fr'] || '').replace(/<\/?[^>]+(>|$)/g, "") === '' ? 'red' : theme.palette.tertiary?.main)}}
        onClick={() => {setUsedActiveLocale('fr');}}
      >FR</Avatar></Tooltip>

      <Typography sx={{fontSize: '0.75rem'}}>{label}</Typography>
      <SunEditor
        height={setting_editor_height}
        getSunEditorInstance={getSunEditorInstance}
        setOptions={{
          defaultStyle: "font-size: 16px; font-family: 'Golos Text', sans-serif;",
          buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['paragraphStyle', 'blockquote'],
            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
            ['fontColor', 'hiliteColor', 'textStyle'],
            ['removeFormat'],
            '/',
            ['outdent', 'indent'],
            ['align', 'horizontalRule', 'list', 'lineHeight'],
            ['table', 'link', 'image', 'video'],
            // ['table', 'link', 'image', 'video', 'math'], // You must add the 'katex' library at options to use the 'math' plugin.
            // ['imageGallery'], // You must add the "imageGalleryUrl".
            ['fullScreen', 'showBlocks', 'codeView'],
            ['preview', 'print'],
            // ['save', 'template'],
            // ['dir', 'dir_ltr', 'dir_rtl'],
            // '/', Line break
          ]
        }}
        setContents={editorContent}
        onChange={(v) => {setEditorContent(v);}}
      />
    </Grid>}
  </>);
}